import { useEffect, useState } from 'react';
import { fetchTronBlock } from '../api/transactions';

export function useTronBlock(number) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(number || '').trim();
    if (!/^[0-9]+$/.test(normalized)) {
      setLoading(false);
      setError('Invalid block number.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchTronBlock(normalized)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Block not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [number]);

  return { data, loading, error };
}
